import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';

import Loader from '../../../app/components/loader';
import styles from './post-list.scss';

class PostListSimple extends Component {
  renderPosts = () => {
    const { posts, ItemComponent, itemProps } = this.props;

    return posts.map((post) => (
      <div key={post._id} className={styles.listItemContainer}>
        <div className={styles.listItem}>
          <ItemComponent post={post} {...itemProps} />
        </div>
      </div>
    ));
  };

  render() {
    const { isLoading, layoutName, posts } = this.props;
    return (
      <div className={styles[layoutName]}>
        <div className={classNames(styles.list, styles[layoutName])}>{posts && this.renderPosts()}</div>
        {isLoading && <Loader />}
      </div>
    );
  }
}

PostListSimple.propTypes = {
  posts: PropTypes.array.isRequired,
  layoutName: PropTypes.string.isRequired,
  ItemComponent: PropTypes.func.isRequired,
  itemProps: PropTypes.object.isRequired,
  isLoading: PropTypes.bool,
};

export default PostListSimple;
